import { useState } from 'react';
import dayjs from 'dayjs';

const createInitialState = () => ({
  countMode: 'Interactions',
  breakdownBy: 'InteractionType',
  currentView: 'Month',
  activeDateInterval: {
    name: 'Last 12 months',
    filter: [dayjs().subtract(1, 'year').startOf('day').format('YYYY-MM-DD')],
  },
  typeOfChart: 'Bar',
});

const useEngagementStatsState = () => {
  const [state, setState] = useState(createInitialState);

  const modifyState = ({ property, newValue }) => {
    setState((prev) => (property === 'CompleteState' ? newValue : { ...prev, [property]: newValue }));
  };

  return { state, modifyState };
};

export { createInitialState };
export default useEngagementStatsState;
